import React from 'react';
import { Button, Typography } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import styles from './styles.module.scss';
import { WAREHOUSE_ROUTES } from '../../../constants/routes';

const { Title, Text } = Typography;

export const NoOrdersFound: React.FC = () => {
  const navigate = useNavigate();

  const handleBackToInbound = () => {
    navigate(WAREHOUSE_ROUTES.inboundPackages);
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.iconContainer}>
          <SearchOutlined className={styles.icon} />
        </div>
        <Title level={3} className={styles.title}>
          No Orders Found
        </Title>
        <Text className={styles.description}>
          {`We couldn't find any orders matching the uploaded delivery note. Please verify the document or try uploading
            again.`}
        </Text>
        <Button type="primary" size="large" onClick={handleBackToInbound} className={styles.backButton}>
          Back to Inbound Packages
        </Button>
      </div>
    </div>
  );
};
